import React from "react";
import {
  LayoutDashboard,
  BookOpenCheck,
  ShoppingCart,
  Warehouse,
  PackagePlus,
  Users,
  Settings,
  ClipboardCheck,
  Tag,
  QrCode,
  BarChart3,
  Plus,
  Layers,
  Boxes,
  ArrowDownCircle,
  BookmarkPlus,
  ArrowUpCircle,
  MapPin,
  ListTree,
  UserPlus,
  BadgePercent,
  Truck,
  MapPinned,
  Building2,
  Flag,
  Globe,
  Coins,
  Receipt,
  Scale,
  Shield,
  FileText,
  FileBarChart,
  FileSpreadsheet,
  Barcode,
  ScanLine,
  ScanFace,
  PackageCheck,
  ChevronDown,
  Menu,
  ChevronLeft,
  ChevronRight,
  LucideProps,
} from "lucide-react";
import '../../../styles/dashboard.css';

export const getMainMenuIcon = (menuKey: string) => {
  switch (menuKey) {
    case "MasterItem":
      return <BookOpenCheck className="menu-icon" />;
    case "Purchase":
      return <ShoppingCart className="menu-icon" />;
    case "GRN":
      return <Warehouse className="menu-icon" />;
    default:
      return <BookOpenCheck className="menu-icon" />;
  }
};


export const getSubmenuIcon = (menuKey: string, submenuKey: string) => {
  if (menuKey === "MasterItem") {
    switch (submenuKey) {
      case "NewItem":
        return <PackagePlus size={16} className="submenu-icon" />;
      case "Contributor":
        return <Users size={16} className="submenu-icon" />;
      case "General":
        return <Settings size={16} className="submenu-icon" />;
      default:
        return <PackagePlus size={16} className="submenu-icon" />;
    }
  }

  if (menuKey === "Purchase") {
    switch (submenuKey) {
      case "GRN":
        return <ClipboardCheck size={16} className="submenu-icon" />;
      default:
        return <ClipboardCheck size={16} className="submenu-icon" />;
    }
  }

  if (menuKey === "GRN") {
    switch (submenuKey) {
      case "PartTag":
        return <Tag size={16} className="submenu-icon" />;
      case "Scanning":
        return <QrCode size={16} className="submenu-icon" />;
      case "Stocks":
        return <BarChart3 size={16} className="submenu-icon" />;
      default:
        return <Tag size={16} className="submenu-icon" />;
    }
  }

  return <Settings size={16} className="submenu-icon" />;
};


export const getListItemIcon = (
  menuKey: string,
  submenuKey: string,
  path: string
) => {
  if (menuKey === "MasterItem" && submenuKey === "NewItem") {
    switch (path) {
      case "newItem":
        return <Plus size={16} className="list-item-icon" />;
      case "itemCategory":
        return <Layers size={16} className="list-item-icon" />;
      case "itemModel":
        return <Boxes size={16} className="list-item-icon" />;
      case "inwardOption":
        return <ArrowDownCircle size={16} className="list-item-icon" />;
      case "newRack":
        return <BookmarkPlus size={16} className="list-item-icon" />;
      case "outwardOption":
        return <ArrowUpCircle size={16} className="list-item-icon" />;
      case "itemAssignedRack":
        return <MapPin size={16} className="list-item-icon" />;
      case "bomtypes":
        return <ListTree size={16} className="list-item-icon" />;
      default:
        return <Plus size={16} className="list-item-icon" />;
    }
  }

  if (menuKey === "MasterItem" && submenuKey === "Contributor") {
    switch (path) {
      case "newContributor":
        return <UserPlus size={16} className="list-item-icon" />;
      case "customerParts":
        return <BadgePercent size={16} className="list-item-icon" />;
      case "supplierParts":
        return <Truck size={16} className="list-item-icon" />;
      case "deliveryPlace":
        return <MapPinned size={16} className="list-item-icon" />;
      default:
        return <UserPlus size={16} className="list-item-icon" />;
    }
  }

  if (menuKey === "MasterItem" && submenuKey === "General") {
    switch (path) {
      case "cityMaster":
        return <Building2 size={16} className="list-item-icon" />;
      case "stateMaster":
        return <Flag size={16} className="list-item-icon" />;
      case "countryMaster":
        return <Globe size={16} className="list-item-icon" />;
      case "currencyMaster":
        return <Coins size={16} className="list-item-icon" />;
      case "gstSlabMaster":
        return <Receipt size={16} className="list-item-icon" />;
      case "uomMaster":
        return <Scale size={16} className="list-item-icon" />;
      case "approvalRole":
        return <Shield size={16} className="list-item-icon" />;
      default:
        return <Settings size={16} className="list-item-icon" />;
    }
  }

  if (menuKey === "Purchase" && submenuKey === "GRN") {
    switch (path) {
      case "newGRN":
        return <FileText size={16} className="list-item-icon" />;
      case "grnSummary":
        return <FileBarChart size={16} className="list-item-icon" />;
      case "grnReport":
        return <FileSpreadsheet size={16} className="list-item-icon" />;
      default:
        return <FileText size={16} className="list-item-icon" />;
    }
  }

  if (menuKey === "GRN" && submenuKey === "PartTag") {
    switch (path) {
      case "IncoBar":
      case "incobar":
        return <Barcode size={16} className="list-item-icon" />;
      default:
        return <Tag size={16} className="list-item-icon" />;
    }
  }

  if (menuKey === "GRN" && submenuKey === "Scanning") {
    switch (path) {
      case "Inward":
        return <ScanLine size={16} className="list-item-icon" />;
      case "Outward":
        return <ScanFace size={16} className="list-item-icon" />;
      default:
        return <QrCode size={16} className="list-item-icon" />;
    }
  }

  if (menuKey === "GRN" && submenuKey === "Stocks") {
    switch (path) {
      case "CurrentStock":
        return <PackageCheck size={16} className="list-item-icon" />;
      default:
        return <BarChart3 size={16} className="list-item-icon" />;
    }
  }

  return <Plus size={16} className="list-item-icon" />;
};

export const DashboardIcon = LayoutDashboard;
export const ChevronDownIcon = ChevronDown;
export const MenuIcon = Menu;
export const ChevronLeftIcon = ChevronLeft;
export const ChevronRightIcon = ChevronRight;